import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "control" }
const _hoisted_3 = { class: "select" }
const _hoisted_4 = ["selected"]
const _hoisted_5 = ["value", "selected"]
const _hoisted_6 = { class: "field" }
const _hoisted_7 = { class: "control" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "field" }
const _hoisted_10 = { class: "control" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "field" }
const _hoisted_13 = { class: "control" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "field" }
const _hoisted_16 = { class: "control" }
const _hoisted_17 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", {
      class: _normalizeClass({'has-background-primary': _ctx.values['ratio'] > 0, 'has-background-danger': _ctx.values['ratio'] <= 0})
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("select", {
              name: "product",
              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateRow && _ctx.updateRow(...args)))
            }, [
              _createElementVNode("option", {
                value: "0",
                selected: _ctx.values['product'] === '0'
              }, "---", 8, _hoisted_4),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredProducts, (product) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: `product-${product.id}`,
                  value: product.id,
                  selected: _ctx.values['product'] === product.id
                }, _toDisplayString(product.name), 9, _hoisted_5))
              }), 128))
            ], 32)
          ])
        ])
      ])
    ], 2),
    _createElementVNode("td", {
      class: _normalizeClass({'has-background-primary': _ctx.values['ratio'] > 0, 'has-background-danger': _ctx.values['ratio'] <= 0})
    }, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("input", {
            class: "input",
            type: "number",
            name: "price",
            value: _ctx.values['price'],
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateRow && _ctx.updateRow(...args))),
            onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.initValue && _ctx.initValue(...args)))
          }, null, 40, _hoisted_8)
        ])
      ])
    ], 2),
    _createElementVNode("td", {
      class: _normalizeClass({'has-background-primary': _ctx.values['ratio'] > 0, 'has-background-danger': _ctx.values['ratio'] <= 0})
    }, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("input", {
            class: "input",
            type: "number",
            name: "ratio",
            value: _ctx.values['ratio'],
            onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updateRow && _ctx.updateRow(...args))),
            onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.initValue && _ctx.initValue(...args)))
          }, null, 40, _hoisted_11)
        ])
      ])
    ], 2),
    ('leg' in _ctx.result)
      ? (_openBlock(), _createElementBlock("td", {
          key: 0,
          class: _normalizeClass({'has-background-primary': _ctx.values['ratio'] > 0, 'has-background-danger': _ctx.values['ratio'] <= 0})
        }, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("input", {
                class: "input",
                disabled: "disabled",
                value: _ctx.result.leg
              }, null, 8, _hoisted_14)
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    ('weighted' in _ctx.result)
      ? (_openBlock(), _createElementBlock("td", {
          key: 1,
          class: _normalizeClass({'has-background-primary': _ctx.values['ratio'] > 0, 'has-background-danger': _ctx.values['ratio'] <= 0})
        }, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("input", {
                class: "input",
                disabled: "disabled",
                value: _ctx.result.weighted
              }, null, 8, _hoisted_17)
            ])
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}